import { useQuery } from '@tanstack/react-query';

import {
  type CompanyId,
  ConfigurationForScheduling,
  type CountryCodeAlpha3,
} from 'common/api/api-types';
import { deliveryOsGatewayApiAgent } from 'common/api/apiAgents';
import { decodeHttpResponse } from 'common/utils';

import queryKeys from './queryKeys';

const SLUG = 'delivery-os-scheduling';

const fetchConfigurations = ({
  companyId,
  countryCode,
}: {
  companyId?: CompanyId;
  countryCode?: CountryCodeAlpha3;
}) =>
  companyId
    ? decodeHttpResponse(
        ConfigurationForScheduling,
        deliveryOsGatewayApiAgent.get(`/configurations/${SLUG}`, {
          params: {
            company: companyId,
            country: countryCode,
          },
        }),
      )
    : Promise.reject(`ERROR: Failed to fetch configuration for ${SLUG}. The company ID is falsy`);

const useConfigurationForScheduling = ({
  companyId,
  countryCode,
}: {
  companyId?: CompanyId;
  countryCode?: CountryCodeAlpha3;
}) =>
  useQuery({
    queryFn: () =>
      fetchConfigurations({
        companyId,
        countryCode,
      }),
    queryKey: queryKeys.forUseConfigurations({
      slug: SLUG,
      companyId,
      countryCode,
    }),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: companyId !== undefined,
  });

export default useConfigurationForScheduling;
